import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from "react";
import { ScrollButton } from "../ScrollButton";
export function SharedTableBody(props) {
    const { data, visibleColumns, adjustedColumns, bodyClassName, rowBodyClassName, gridTemplateColumns, onRowClick, isRowSelected, highlightedStatuses = {}, getRowHighlightClassName, } = props;
    const bodyRef = useRef(null);
    return (_jsxs("div", { className: bodyClassName, ref: bodyRef, children: [data.map((item) => {
                const selected = isRowSelected?.(item) || false;
                const isLate = item.late > 0 &&
                    item.status.name !== "Выдан" &&
                    item.status.name !== "Отказ";
                const notificationHighlightClass = getRowHighlightClassName?.(item) ?? "";
                const statusId = item.status?.id ?? item.status;
                const isHighlighted = statusId && highlightedStatuses[statusId];
                // notificationHighlightClass имеет приоритет над highlightedStatuses
                const highlightClass = !notificationHighlightClass && isHighlighted
                    ? `${rowBodyClassName}_highlighted_${statusId}`
                    : "";
                const isArchive = item.staleMarks?.archive === true;
                const archiveClass = isArchive
                    ? `${rowBodyClassName}_archive`
                    : "";
                // Собираем классы для строки
                const rowClassName = [
                    rowBodyClassName,
                    highlightClass,
                    notificationHighlightClass,
                    archiveClass,
                    isLate ? `${rowBodyClassName}--late` : "",
                    selected ? `${rowBodyClassName}--selected` : "",
                ]
                    .filter(Boolean)
                    .join(" ");
                return (_jsx("div", { style: {
                        display: "grid",
                        gridTemplateColumns: gridTemplateColumns,
                    }, className: rowClassName, onClick: () => onRowClick?.(item), children: visibleColumns.map((colId) => {
                        const col = adjustedColumns[colId];
                        if (!col)
                            return null;
                        return (_jsx("div", { className: col.className, children: col.renderCell
                                ? col.renderCell(item)
                                : `Cell ${colId} - ${item.key}` }, colId));
                    }) }, item.key ?? item.id));
            }), _jsx(ScrollButton, { containerRef: bodyRef, scrollThreshold: 1600 })] }));
}
